import React from 'react';
import { Helmet } from 'react-helmet';

import NavigationBar from '../NavigationBar';
import Footer from '../Footer';
import { useTranslation } from '../../i18n';

// Thin page: the canonical privacy policy lives on the marketing site
// (securepaper.app/privacy, PL: /pl/privacy) so the text exists in one place.
const Privacy = () => {
  const { t, lang } = useTranslation();
  const url = lang === 'pl'
    ? 'https://securepaper.app/pl/privacy'
    : 'https://securepaper.app/privacy';

  return (
    <>
      <Helmet>
        <title>Privacy Policy - SecurePaper</title>
        <meta name="description" content="How SecurePaper handles your data: content is encrypted in your browser and never stored; what we do store and why." />
        <link rel="canonical" href="https://securepaper.app/privacy" />
      </Helmet>
      <NavigationBar />

      <div className="container">
        <div className="py-5 text-center" style={{ minHeight: '50vh' }}>
          <h1>{t('legal.privacyTitle')}</h1>
          <p className="text-muted mx-auto mt-3" style={{ maxWidth: '560px' }}>
            {t('legal.canonicalNote')}
          </p>
          <a href={url} className="btn btn-primary mt-3">
            <i className="fa fa-arrow-up-right-from-square mr-2" aria-hidden="true"></i>
            {t('legal.openFull')}
          </a>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Privacy;
